import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import i18n from './locales/i18n';
import print from "vue3-print-nb";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import ElementPlus from "element-plus";
import "@/style/index.css"
import "element-plus/dist/index.css";
import "@/assets/iconfont/iconfont.css";
import "@/assets/css/base.css";
import "@/assets/css/response.css";


import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

const app = createApp(App);


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(ElementPlus);
app.use(router);
app.use(store);
app.use(i18n);
app.use(print);
app.mount("#app");
